<ul *ngIf="navItems && navItems.length > 0" class="nav flex-column">
  <li *ngFor="let navItem of navItems" class="nav-item">
    <a [attr.id]="navItem.id" *ngIf="visibleItems.indexOf(navItem.id) !== -1" class="nav-link" [routerLink]="navItem.link" >{{navItem.name}}</a>
  </li>
</ul>
